export default __webpack_public_path__ + "static/media/noResultFound.af1f742c.jpg";